// Ported from src/views/auth/auth-callbacks/BoxOAuth2Client.js — same client
// id/redirect, restructured to fit v2's service conventions.
const { VITE_BOX_AUTH_CLIENT_ID } = import.meta.env;

export default class BoxOAuth2Client {
  static titleName = "Box";
  #clientId = VITE_BOX_AUTH_CLIENT_ID;
  #redirectUri = location.origin + "/box_oauth2_callback";

  async getAuthWithRedirect(transitedState) {
    const authUrl = new URL(`https://account.box.com/api/oauth2/authorize`);
    authUrl.searchParams.set("client_id", this.#clientId);
    authUrl.searchParams.set("redirect_uri", this.#redirectUri);
    authUrl.searchParams.set("response_type", "code");
    authUrl.searchParams.set("state", window.btoa(JSON.stringify(transitedState)));
    window.open(authUrl.toString(), "_self");
  }

  async callbackHandler(query = {}) {
    const { code, error, error_description } = query;
    if (error) throw new Error(`${error}:${error_description}`);
    return { access_token: code, refresh_token: "" };
  }
}
